export const inputCls =
  "w-full h-12 rounded-xl bg-white/[0.04] border border-white/10 px-4 text-[15px] text-white placeholder:text-slate-500 focus:outline-none focus:border-[var(--accent)]/60 transition-colors";

export const Field = ({ label, error, children, hint }) => (
  <label className="block">
    <span className="text-[11px] font-mono-epl uppercase tracking-wider text-slate-400">{label}</span>
    <div className="mt-2">{children}</div>
    {hint && !error && <span className="mt-1.5 block text-xs text-slate-500">{hint}</span>}
    {error && <span className="mt-1.5 block text-xs text-red-400">{error}</span>}
  </label>
);

export const TextInput = ({ testid, ...props }) => <input data-testid={testid} className={inputCls} {...props} />;

export const TextArea = ({ testid, ...props }) => (
  <textarea data-testid={testid} rows={2} className={`${inputCls} h-auto py-3 resize-none`} {...props} />
);

export const Choice = ({ options, value, onChange, testid }) => (
  <div className="flex flex-wrap gap-2">
    {options.map((o) => (
      <button
        type="button"
        key={String(o.value)}
        data-testid={`${testid}-${String(o.value).toLowerCase()}`}
        onClick={() => onChange(o.value)}
        className={`h-12 px-5 rounded-xl border text-[15px] font-medium transition-colors ${value === o.value ? "bg-[var(--accent)] text-[#070a11] border-[var(--accent)]" : "border-white/15 text-slate-200 hover:border-white/40"}`}
      >
        {o.label}
      </button>
    ))}
  </div>
);

export const Check = ({ checked, onChange, children, testid, error }) => (
  <label className="flex gap-3 items-start cursor-pointer py-2">
    <input type="checkbox" data-testid={testid} checked={checked} onChange={(e) => onChange(e.target.checked)} className="mt-1 w-5 h-5 accent-[#ccff00] shrink-0" />
    <span className={`text-sm leading-relaxed ${error ? "text-red-300" : "text-slate-300"}`}>{children}</span>
  </label>
);

export const StepTitle = ({ eyebrow, title, sub }) => (
  <div className="mb-8">
    <p className="eyebrow">{eyebrow}</p>
    <h1 className="mt-4 font-display font-bold tracking-tight text-3xl sm:text-4xl">{title}</h1>
    {sub && <p className="mt-3 text-slate-400">{sub}</p>}
  </div>
);
